import { render, staticRenderFns } from "./detailSuccess.vue?vue&type=template&id=2be0e09d"
import script from "./detailSuccess.vue?vue&type=script&lang=js"
export * from "./detailSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports